import React from "react";
import HierarchyFinancialManagement from "src/components/HierarchyFinancialManagement";
import { useTranslation } from "src/context/Translations/context";
import { ITypeFinancialManagement } from "src/pages/FinancialManagement/interface";
import { IHierarchy } from "src/pages/FinancialManagement/components/ScreenBudgets/interface";

const HierarchyVariableCosts: React.FC<IHierarchy> = ({
	ofa001Id,
	ofa002Id,
	onClickLine
}) => {
	const {translate} = useTranslation();
	return <HierarchyFinancialManagement 
		method="VariableCosts/ListHierarchy"
		ofa001Id={ofa001Id}
		ofa002Id={ofa002Id}
		onClickLine={onClickLine}
		title={translate("Custos variáveis")}
		type={ITypeFinancialManagement.VARIABLE_COSTS}
	/>;
};

export default HierarchyVariableCosts;
